import { useState } from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import PenalitatiGenerale from './calculatoare/PenalitatiGenerale';
import PenalitatiANAF from './calculatoare/PenalitatiANAF';
import CalculatorDobanzi from './calculatoare/CalculatorDobanzi';
import TaxeJudiciare from './calculatoare/TaxeJudiciare';
import CalculatorTermene from './calculatoare/CalculatorTermene';
import CalculatorMatematic from './calculatoare/CalculatorMatematic';

function TabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`calculator-tabpanel-${index}`}
      aria-labelledby={`calculator-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 2 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `calculator-tab-${index}`,
    'aria-controls': `calculator-tabpanel-${index}`,
  };
}

const Calculatoare = () => {
  const [value, setValue] = useState(0);

  const handleChange = (_, newValue) => {
    setValue(newValue);
  };

  return (
    <Box> 
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs 
          value={value} 
          onChange={handleChange} 
          aria-label="calculatoare tabs"
          variant="fullWidth"
          sx={{
            '& .MuiTab-root': {
              minWidth: 'auto',
              padding: '8px 16px',
              fontSize: '0.875rem',
              fontWeight: 500,
              textTransform: 'none',
              borderRadius: '8px 8px 0 0',
              margin: '0 2px',
              transition: 'all 0.2s ease-in-out',
              '&:hover': {
                backgroundColor: 'rgba(25, 118, 210, 0.04)',
                transform: 'translateY(-1px)',
              },
              '&.Mui-selected': {
                backgroundColor: 'rgba(25, 118, 210, 0.08)',
                color: '#1976d2',
                fontWeight: 600,
              }
            },
            '& .MuiTabs-indicator': {
              height: 3,
              borderRadius: '3px 3px 0 0',
              background: 'linear-gradient(45deg, #1976d2, #42a5f5)',
            }
          }}
        >
          <Tab label="Penalități generale" {...a11yProps(0)} />
          <Tab label="Penalități ANAF" {...a11yProps(1)} />
          <Tab label="Dobânzi" {...a11yProps(2)} />
          <Tab label="Taxe" {...a11yProps(3)} />
          <Tab label="Termene" {...a11yProps(4)} />
          <Tab label="Calculator" {...a11yProps(5)} />
        </Tabs>
      </Box>
      
      <TabPanel value={value} index={0}>
        <PenalitatiGenerale />
      </TabPanel>
      
      <TabPanel value={value} index={1}>
        <PenalitatiANAF />
      </TabPanel>
      
      <TabPanel value={value} index={2}>
        <CalculatorDobanzi />
      </TabPanel>
      
      <TabPanel value={value} index={3}>
        <TaxeJudiciare />
      </TabPanel>
      
      <TabPanel value={value} index={4}>
        <CalculatorTermene />
      </TabPanel>
      
      <TabPanel value={value} index={5}>
        <CalculatorMatematic />
      </TabPanel>
    </Box>
  );
};

export default Calculatoare;